import $ from 'jquery';

$(document).on('ready turbo:load turbo:frame-load', function () {
  $('.hero-slideOut > p:first').each(function (i, e) {
    if ($(e).height()! < 40) {
      $(e).parent().next().hide();
    }
  });

  $('#hero_details').on('change', function () {
    $('.hero-background').toggleClass(
      'hero-background--dark',
      $(this).is(':checked')
    );
  });
});
